import styled from 'styled-components';

/** The design's `.empty-val` — quieter than the values around it, and lighter. */
export const Empty = styled.span`
  color: var(--text-faint);
  font-weight: var(--fw-regular);
`;

/**
 * Machine-generated text — IDs, timestamps, counts. Mono with tabular
 * numerals so a column of them lines up digit for digit.
 */
export const Mono = styled.span`
  font-family: var(--font-mono);
  font-size: var(--fs-mono);
  font-variant-numeric: tabular-nums;

  /*
   * Always left-to-right, whatever paragraph it lands in. A timestamp is all
   * digits and dots — no strong directional character in it — so dropped into
   * an Arabic detail row it would take that row's direction and could come
   * out reversed. It is machine text and reads one way only.
   */
  unicode-bidi: normal;
  direction: ltr;
`;
